import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from 'components/icons';

interface ErrorStateProps {
  /** What failed, in the user's terms — not the exception message. */
  title?: string;
  description?: string;
  onRetry?: () => void;
  retrying?: boolean;
  compact?: boolean;
}

/**
 * Replaces the `catch {}` / console.error pattern, which left the user
 * looking at an empty widget with no explanation and no way to recover.
 */
const ErrorState: React.FC<ErrorStateProps> = ({
  title = "We couldn't load this",
  description = 'The request did not come back. This is usually temporary.',
  onRetry,
  retrying = false,
  compact = false,
}) => (
  <div
    role="alert"
    className={`text-center ${compact ? 'py-6' : 'py-10'} px-4`}
  >
    <ExclamationTriangleIcon className="mx-auto h-9 w-9 text-warning" />
    <h3 className="mt-3 text-body text-content font-semibold">{title}</h3>
    <p className="mt-1 text-body text-content-muted max-w-prose mx-auto">{description}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        disabled={retrying}
        className="mt-4 inline-flex items-center gap-1.5 text-label font-semibold text-accent hover:text-accent-hover disabled:opacity-60"
      >
        <ArrowPathIcon className={`h-4 w-4 ${retrying ? 'animate-spin' : ''}`} aria-hidden="true" />
        {retrying ? 'Retrying…' : 'Try again'}
      </button>
    )}
  </div>
);

export default ErrorState;
